import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../authentication/AuthContext';
import '../styles/PricingPage.css';
import { event } from '../services/analyticsService';

function PricingPage() {
  const navigate = useNavigate();
  const { isAdmin, hasActiveSubscription, walletBalance, user } = useAuth();
  const [openFaq, setOpenFaq] = useState(null);

  const handleGetStarted = () => {
    // Track free plan selection
    event({
      action: 'select_plan',
      category: 'pricing',
      label: 'free_plan',
      value: 0
    });
    
    // Check if user is authenticated
    if (!user) {
      navigate('/login', { 
        state: { 
          from: '/research',
          message: 'Please log in to access the app and start your research'
        } 
      });
      return;
    }
    
    navigate('/research');
  };

  const handleSubscribe = () => {
    // Track subscription plan selection
    event({
      action: 'select_plan',
      category: 'pricing',
      label: 'subscription_plan',
      value: 20
    });
    
    // Check if user is authenticated
    if (!user) {
      navigate('/login', { 
        state: { 
          from: '/account',
          message: 'Please log in to access the app and subscribe to a plan'
        } 
      });
      return;
    }
    
    // Navigate to account page with subscription flag
    navigate('/account', { state: { subscribe: true } });
  };


  const handleManageSubscription = () => {
    // Track manage subscription click
    event({
      action: 'manage_subscription',
      category: 'account',
      label: 'from_pricing_page'
    });
    
    navigate('/account');
  };

  return (
    <div className="pricing-page">
      <div className="hero hero-1 top-hero">
        <h1>Simple, Transparent Pricing</h1>
        <h3>Choose the plan that fits your research needs</h3>
      </div>
    <div className="hero hero-1">

      <div className="pricing-container">
        <div className="pricing-card">
          <h2>Free</h2>
          <p className="price">€0</p>
          <p className="period">monthly</p>
          <div className="credit-info">
            <ul>
              <li>1 research per week</li>
              <li>Up to 10 questions per research</li>
              <li>Up to 20 personas per research</li>
            </ul>
          </div>
          <button 
            className="pricing-btn" 
            onClick={handleGetStarted}
          >
            Start Free
          </button>
        </div>

        <div className={`pricing-card ${hasActiveSubscription ? 'selected' : ''}`}>
          <h2>Subscription</h2>
          <p className="price">€20</p>
          <p className="period">monthly</p>
          <div className="credit-info">
            <ul>
              <li>10 researches per week</li>
              <li>Up to 15 questions per research</li>
              <li>Up to 100 personas per research</li>
            </ul>
          </div>
          {hasActiveSubscription ? (
            <button 
              className="pricing-btn"
              onClick={handleManageSubscription}
            >
              Manage Subscription
            </button>
          ) : (
            <button 
              className="pricing-btn" 
              onClick={handleSubscribe}
            >
              Subscribe Now
            </button>
          )}
        </div>

      </div>

      <div className="contact-for-more">
        <p>Need higher limits or custom solutions? <a href="mailto:business@instantflows.com">Contact us</a></p>
      </div>

      {isAdmin && (
        <div className="container textbox">
          <h3>Admin Account</h3>
          <p>You have unlimited access to all features. 20 questions and 200 personas max per research.</p>
        </div>
      )}
    </div>
    <div className="hero hero-1">

      {/* <div className="faq-container">
        <h2>Frequently Asked Questions</h2>
        <div className="faq-sections">
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <div 
                className={`faq-question ${openFaq === index ? 'active' : ''}`}
                onClick={() => toggleFaq(index)}
              >
                <h3>{faq.question}</h3>
                <span className="faq-icon">{openFaq === index ? '−' : '+'}</span>
              </div>
              <div className={`faq-answer ${openFaq === index ? 'open' : ''}`}>
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div> */}
    </div>
    </div>
  );
}

export default PricingPage;